/* 30.09.2026: винесено з layout/theme.liquid (раніше inline на кожній сторінці), підключено з defer */
// Відправка йде через бекенд (kickflip) — токен бота живе тільки на сервері
const BT_NOTIFY_URL = 'https://web-production-05000.up.railway.app/site/notify';

// Extract readable config details from a cart item's properties for Telegram.
// Skips internal flags (_upsell, preview_url, bricktopia_price_*) and
// surfaces builder_config JSON fields (frame size, color, figures count,
// keychain, type) + Design ID + preview link.
function extractItemConfigForTelegram(item) {
    const out = [];
    if (!item || !item.properties) return out;
    const props = item.properties;
    const pushIf = (label, val) => {
        if (val !== undefined && val !== null && val !== '' && val !== false) {
            out.push('     • ' + label + ': ' + val);
        }
    };

    let cfg = null;
    /* _builder_config — нове імʼя (приховане від покупця), builder_config — старі кошики */
    const rawCfg = props._builder_config || props.builder_config || props['builder_config'];
    if (rawCfg) {
        try { cfg = typeof rawCfg === 'string' ? JSON.parse(rawCfg) : rawCfg; }
        catch (e) { cfg = null; }
    }
    if (cfg) {
        if (cfg.frameSize)    pushIf('Розмір рамки', cfg.frameSize);
        if (cfg.frameColor)   pushIf('Колір рамки', cfg.frameColor);
        if (cfg.figuresCount) pushIf('Кількість фігурок', cfg.figuresCount);
        if (cfg.keychain !== undefined) pushIf('Брелок', cfg.keychain ? 'Так' : 'Ні');
        if (cfg.delayDays)    pushIf('Затримка (днів)', cfg.delayDays);
        if (cfg.type)         pushIf('Тип', cfg.type);
    }

    const designId = props._figure_config_id || props.figure_config_id
        || props._frame_config_id || props.frame_config_id
        || props._pet_config_id || props.pet_config_id;
    if (designId) out.push('     • Design ID: ' + designId);

    const previewUrl = props._preview_url || props.preview_url || (cfg && cfg.preview);
    if (previewUrl) out.push('     🖼 Прев`ю: ' + previewUrl);

    Object.keys(props).forEach((k) => {
        if (k.charAt(0) === '_') return;
        if (k === 'builder_config' || k === 'preview_url') return;
        if (k === 'figure_config_id' || k === 'frame_config_id' || k === 'pet_config_id') return;
        if (k.indexOf('bricktopia_price_') === 0) return;
        let v = props[k];
        if (v === '' || v === null || v === undefined) return;
        let vStr = String(v);
        if (vStr.length > 80) vStr = vStr.slice(0, 77) + '…';
        out.push('     • ' + k + ': ' + vStr);
    });
    return out;
}

// Format cart contents into readable Telegram-friendly text.
// Takes the already fetched /cart.js object (null = cart could not be read → '').
function cartTelegramText(cart) {
    try {
        if (!cart) return '';
        if (!cart.items || cart.items.length === 0) {
            return '\n\n🛒 Кошик: порожній';
        }
        const lines = ['', '', '🛒 Кошик (' + cart.item_count + ' шт):'];
        cart.items.forEach((item, i) => {
            const title = (item.product_title || item.title || '').slice(0, 60);
            const qty = item.quantity || 1;
            const price = item.line_price ? (item.line_price / 100).toFixed(2) : '?';
            const variant = item.variant_title && item.variant_title !== 'Default Title' ? ' (' + item.variant_title + ')' : '';
            lines.push((i + 1) + '. ' + title + variant + ' × ' + qty + ' = ' + price + ' ' + (cart.currency || 'UAH'));
            // Append per-item config details
            const cfg = extractItemConfigForTelegram(item);
            if (cfg.length > 0) {
                lines.push(...cfg);
            }
        });
        if (cart.total_price) {
            lines.push('💰 Усього: ' + (cart.total_price / 100).toFixed(2) + ' ' + (cart.currency || 'UAH'));
        }
        return lines.join('\n');
    } catch (e) {
        return '';
    }
}

// Returns a string ready to append to the message, or '' if cart is empty.
async function buildCartTelegramSection() {
    try {
        const res = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
        if (!res.ok) return '';
        const cart = await res.json();
        return cart ? cartTelegramText(cart) : '\n\n🛒 Кошик: порожній';
    } catch (e) {
        return '';
    }
}

// Повний текст заявки — для Telegram (старий шлях і запасний шлях bt-lead.js).
function contactPopupMessage(name, phone, comment, cartSection) {
    return `🔔 Нова заявка з сайту:
📝 Ім'я: ${name}
📞 Телефон: ${phone}
💬 Коментар: ${comment || 'Не вказано'}
🌐 Сторінка: ${window.location.href}
⏰ Час: ${new Date().toLocaleString('uk-UA')}${cartSection}`;
}

// Функция отправки сообщения в Telegram + дані кошика для швидкої консультації.
// Контракт для обробника форми: resolve true — доставлено, throw — ні.
async function sendToTelegram(name, phone, comment) {
    // Є bt-lead.js (asset, defer; до сабміту він уже виконався) — заявка йде в
    // склад, у Telegram склад шле коротке сповіщення. Склад недоступний —
    // bt-lead.js сам шле цей самий повний текст у kickflip.
    const btLead = window.btLead;
    if (btLead && typeof btLead.send === 'function') {
        const c = (typeof btLead.cart === 'function' ? await btLead.cart() : null) || {};
        const res = await btLead.send({
            kind: 'contact_popup',
            source: 'contact-popup',
            name: name,
            phone: phone,
            contact_method: 'Телефон',
            contact: phone,
            message: comment,
            details: { cart: c.summary || null }
        }, { fallbackText: contactPopupMessage(name, phone, comment, cartTelegramText(c.raw || null)) });
        if (res && res.ok) return true;
        throw new Error('Lead not delivered: ' + (res && res.status));
    }

    const cartSection = await buildCartTelegramSection();
    const message = contactPopupMessage(name, phone, comment, cartSection);

    return fetch(BT_NOTIFY_URL, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ text: message })
    })
    .then(response => response.json())
    .then(data => {
        if (data.ok) {
            return true;
        } else {
            throw new Error('Notify API error: ' + JSON.stringify(data));
        }
    });
}

document.addEventListener('DOMContentLoaded', function() {
   // Получаем элементы
const closePopupBtn = document.getElementById('closePopupBtn');
const popupOverlay = document.getElementById('popupOverlay');
const contactForm = document.getElementById('contactForm');

// Массив селекторов для кнопок, которые должны открывать popup
const buttonSelectors = [
    '.button-message',
  '.phone-buttoner',
  '#shopify-section-template--18146602418264__section_4gmayB > div.section.section--page-width.color-scheme-4 > div.border-style.custom-section-content > div > div:nth-child(4) > div > div.product-card-amzrpehpbow5itnboyaigenblock5bf0818qmanma.medium-1 > div > div.product-card-actions-amzrpehpbow5itnboyaigenblock5bf0818qmanma > a.product-card-button-amzrpehpbow5itnboyaigenblock5bf0818qmanma.card2-btn',
  '#shopify-section-template--18146602418264__section_4gmayB > div.section.section--page-width.color-scheme-4 > div.border-style.custom-section-content > div > div:nth-child(4) > div > div.product-card-amzrpehpbow5itnboyaigenblock5bf0818qmanma.medium-2 > div > div.product-card-actions-amzrpehpbow5itnboyaigenblock5bf0818qmanma > a.product-card-button-amzrpehpbow5itnboyaigenblock5bf0818qmanma.card3-btn',
  '#shopify-section-template--18146602418264__section_cXheVj > div.section.section--page-width.color-scheme-3d8697eb-4f7c-4204-a128-fcafc52134c2 > div.border-style.custom-section-content > div > div.mobile-hero-section-as3njrk5wzknuotngaaigenblockd089e28afunwj.abcde > div > div.mobile-hero-buttons-container-as3njrk5wzknuotngaaigenblockd089e28afunwj',
    '#shopify-section-template--18146602418264__section_cXheVj > div.section.section--page-width.color-scheme-3d8697eb-4f7c-4204-a128-fcafc52134c2 > div.border-style.custom-section-content > div > div.hero-block-awggrs3jdt3ryu1bwmaigenblock5fbfffacngjeq.abc > div.hero-block__container-awggrs3jdt3ryu1bwmaigenblock5fbfffacngjeq > div.hero-block__content-awggrs3jdt3ryu1bwmaigenblock5fbfffacngjeq > div > div.hero-block__buttons-container-awggrs3jdt3ryu1bwmaigenblock5fbfffacngjeq > a:nth-child(1)',
    // Добавьте здесь дополнительные селекторы
    // '.custom-button',
    // '#special-btn',
    // '[data-popup-trigger]'
];

// Функция открытия popup
function openPopup(e) {
    e.preventDefault();
    popupOverlay.classList.add('active');
    document.body.style.overflow = 'hidden';
}

// Функция закрытия popup
function closePopup() {
    popupOverlay.classList.remove('active');
    document.body.style.overflow = '';
}

// Функция для добавления обработчиков событий ко всем кнопкам по селекторам
function initPopupButtons() {
    buttonSelectors.forEach(selector => {
        const buttons = document.querySelectorAll(selector);
        buttons.forEach(btn => {
            if (btn.__popupBound) return;
            btn.__popupBound = true;
            btn.addEventListener('click', openPopup);
        });
    });
}

// Инициализация
initPopupButtons();

// Event delegation — handles dynamically added buttons (e.g. new sections in theme editor)
// without needing to re-run initPopupButtons. Matches any .button-message anywhere in DOM.
document.addEventListener('click', function (e) {
    const trigger = e.target.closest('.button-message, [data-popup-trigger]');
    if (trigger && popupOverlay) {
        e.preventDefault();
        popupOverlay.classList.add('active');
        document.body.style.overflow = 'hidden';
    }
});

// Re-bind specific selectors when Shopify loads new sections in the theme editor
document.addEventListener('shopify:section:load', initPopupButtons);

// Обработчик закрытия popup
if (closePopupBtn) {
    closePopupBtn.addEventListener('click', closePopup);
}

// Закрытие по клику на overlay
if (popupOverlay) {
    popupOverlay.addEventListener('click', (e) => {
        if (e.target === popupOverlay) {
            closePopup();
        }
    });
}

    // Закрытие по Escape
    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && popupOverlay.classList.contains('active')) {
            closePopup();
        }
    });

    // Копирование email при клике
    const copyEmailBtn = document.getElementById('copyEmailBtn');
    if (copyEmailBtn) {
        copyEmailBtn.addEventListener('click', function(e) {
            e.preventDefault();
            const email = 'mail@bricktopia.store';
            
            // Копируем в буфер обмена
            navigator.clipboard.writeText(email).then(function() {
                // Показываем уведомление об успешном копировании
                const originalText = copyEmailBtn.innerHTML;
                copyEmailBtn.innerHTML = `
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/>
                    </svg>
                    Скопійовано!
                `;
                
                // Возвращаем исходный текст через 2 секунды
                setTimeout(function() {
                    copyEmailBtn.innerHTML = originalText;
                }, 2000);
            }).catch(function() {
                // Fallback для старых браузеров
                alert('Email: ' + email);
            });
        });
    }

    // Обработка отправки формы с отправкой в Telegram
    contactForm.addEventListener('submit', function(e) {
        e.preventDefault();
        
        // Получаем данные из формы
        const formData = new FormData(contactForm);
        const name = contactForm.querySelector('input[type="text"]').value.trim();
        const phone = contactForm.querySelector('input[type="tel"]').value.trim();
        const comment = contactForm.querySelector('textarea').value.trim();

        // Простая валидация
        if (!name || !phone) {
            alert('Будь ласка, заповніть обов\'язкові поля');
            return;
        }

        // Блокируем кнопку отправки
        const submitBtn = contactForm.querySelector('button[type="submit"]');
        const originalText = submitBtn.textContent;
        submitBtn.disabled = true;
        submitBtn.textContent = 'Відправляємо...';

        // Отправляем в Telegram
        sendToTelegram(name, phone, comment)
            .then(() => {
                alert('Дякуємо! Ми зв\'яжемося з вами найближчим часом.');
                closePopup();
                contactForm.reset();
            })
            .catch((error) => {
                console.error('Error sending to Telegram:', error);
                alert('Помилка при відправці. Спробуйте ще раз або зв\'яжіться з нами іншим способом.');
            })
            .finally(() => {
                // Разблокируем кнопку
                submitBtn.disabled = false;
                submitBtn.textContent = originalText;
            });
    });

    // Предотвращаем закрытие popup при клике внутри контейнера
    document.querySelector('.popup-container').addEventListener('click', function(e) {
        e.stopPropagation();
    });
});
